module.exports = __webpack_public_path__ + "static/media/cq_plus_b.252ee250.svg";